export const OfferAvailability = Object.freeze({
	InStock: 'https://schema.org/InStock',
	OutOfStock: 'https://schema.org/OutOfStock',
	PreOrder: 'https://schema.org/PreOrder',
});

export type OfferAvailabilityValue =
	(typeof OfferAvailability)[keyof typeof OfferAvailability];
